import React from 'react';
import './style.scss';
import { NavLink } from 'react-router-dom';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { IconName, findIcon } from 'utils/handleIcon';
import { DomesticRealEstatePositionListItemFragment, PositionListItemFragment } from 'views/utils/graphql/graphql';
import { ListItem } from 'views/mutual/list';
import { PagePathFactory } from 'constants/pagePath';
import { formatPrice } from 'views/utils/converter';
import { IssuanceDocumentType } from 'constants/IssuanceDocument';
import { ProductType, ProductTypeMap } from 'constants/productType';
import { PositionStatus, PositionStatusMap } from 'constants/position';

type DomesticrealEstatePositionListItemProps = {
  itemIndex: number;
  position: DomesticRealEstatePositionListItemFragment;
};

const fileIcon = findIcon(IconName.file);

const DomesticRealEstatePositionListItem: React.FC<DomesticrealEstatePositionListItemProps> = ({
  itemIndex,
  position,
}: DomesticrealEstatePositionListItemProps) => {
  return (
    <ListItem itemIndex={itemIndex} className="domesticRealEstatePositionListItem">
      <div className="domesticRealEstatePositionListItem_realEstateName">
        <div className="domesticRealEstatePositionListItem_label">物件名</div>
        <div className="domesticRealEstatePositionListItem_value">{position.RealEstateName}</div>
      </div>
      <div className="domesticRealEstatePositionListItem_transferDate">
        <div className="domesticRealEstatePositionListItem_label">取得日</div>
        <div className="domesticRealEstatePositionListItem_value">{position.TransferDate}</div>
      </div>
      <div className="domesticRealEstatePositionListItem_firstTransferQuantity">
        <div className="domesticRealEstatePositionListItem_label">購入個数（個）</div>
        <div className="domesticRealEstatePositionListItem_value">{position.FirstTransferQuantity}</div>
      </div>
      <div className="domesticRealEstatePositionListItem_firstTransferRealEstatePrice">
        <div className="domesticRealEstatePositionListItem_label">購入価格(¥)</div>
        <div className="domesticRealEstatePositionListItem_value">
          {formatPrice(position.FirstTransferRealEstatePrice)}
        </div>
      </div>
      <div className="domesticRealEstatePositionListItem_currentQuantity">
        <div className="domesticRealEstatePositionListItem_label">現在保有個数（個）</div>
        <div className="domesticRealEstatePositionListItem_value">{position.CurrentQuantity}</div>
      </div>
      <div className="domesticRealEstatePositionListItem_currentRealEstatePrice">
        <div className="domesticRealEstatePositionListItem_label">現在保有価格</div>
        <div className="domesticRealEstatePositionListItem_value">{formatPrice(position.CurrentRealEstatePrice)}</div>
      </div>
      <div className="domesticRealEstatePositionListItem_holdingPeriod">
        <div className="domesticRealEstatePositionListItem_label">取得日からの保有期間</div>
        <div className="domesticRealEstatePositionListItem_value">{position.HoldingPeriod}</div>
      </div>
      <div className="domesticRealEstatePositionListItem_inheritanceTaxAssessment">
        <div className="domesticRealEstatePositionListItem_label">相続税評価額/1,000万円あたり（円）</div>
        <div className="domesticRealEstatePositionListItem_value">{formatPrice(position.InheritanceTaxAssessment)}</div>
      </div>
      <div className="domesticRealEstatePositionListItem_inheritanceTaxAssessmentSmallResidence">
        <div className="domesticRealEstatePositionListItem_label">相続税評価額（小規模宅地）（円）</div>
        <div className="domesticRealEstatePositionListItem_value">
          {formatPrice(position.InheritanceTaxAssessmentSmallResidence)}
        </div>
      </div>
      <div className="domesticRealEstatePositionListItem_dividendYield">
        <div className="domesticRealEstatePositionListItem_label">配当利回り（想定）（%）</div>
        <div className="domesticRealEstatePositionListItem_value">{position.DividendYield}</div>
      </div>
      <div className="domesticRealEstatePositionListItem_contract">
        <div className="domesticRealEstatePositionListItem_label">契約関連書類</div>
        <div className="domesticRealEstatePositionListItem_value">
          {position.HasIssuanceDoc ? (
            <NavLink
              data-label="契約関連書類"
              to={PagePathFactory.issuanceDocumentContract(
                ProductTypeMap[position.ProductType as ProductType]?.documentType,
                position.Symbol,
              )}
            >
              <SvgIcon icon={fileIcon} size={IconSize.icon_s} />
            </NavLink>
          ) : (
            <div className="disabled">
              <SvgIcon icon={fileIcon} size={IconSize.icon_s} />
            </div>
          )}
        </div>
      </div>
    </ListItem>
  );
};

export type DomesticRealEstatePositionListProps = {
  items: Array<DomesticRealEstatePositionListItemFragment | null>;
};
export const DomesticRealEstatePositionList = ({ items }: DomesticRealEstatePositionListProps) => {
  return (
    <>
      {items
        ?.filter((x) => (x ? true : false))
        .map((item, index) => (
          <DomesticRealEstatePositionListItem key={index} itemIndex={index} position={item!} />
        ))}
    </>
  );
};
